import request from '../../axios';

export const getSummaryStateList = async () => {
  const {data}: {data: ISummaryState[]} = await request.get(
    '/api/v2/base/summary-state-list',
  );

  return data;
};
